import { render } from "./IconElipsisVertical.vue?vue&type=template&id=3b3b2174"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/icon/IconElipsisVertical.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3b3b2174"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3b3b2174', __exports__)) {
    api.reload('3b3b2174', __exports__)
  }
  
  module.hot.accept("./IconElipsisVertical.vue?vue&type=template&id=3b3b2174", () => {
    api.rerender('3b3b2174', render)
  })

}


export default __exports__